import { createSelector } from "reselect";
import _ from "lodash";
export const selectSearchValue = ({ JobPackList_reducer }) => {
    return JobPackList_reducer.search;
};
export const selectOrderByValue = ({ JobPackList_reducer }) => {
    return JobPackList_reducer.orderBy;
};
export const selectOrderKeyValue = ({ JobPackList_reducer }) => {
    return JobPackList_reducer.orderKey;
};
export const selectDateFrom = ({ JobPackList_reducer }) => {
    return JobPackList_reducer.dateFrom;
};
export const selectDateTo = ({ JobPackList_reducer }) => {
    return JobPackList_reducer.dateTo;
};
export const selectJobPacks = ({ JobPackList_reducer }) => {
    if (
        typeof JobPackList_reducer.jobPacks === "undefined" ||
        JobPackList_reducer.jobPacks === null ||
        JobPackList_reducer.jobPacks === false ||
        JobPackList_reducer.jobPacks === undefined
    )
        return [];

    return JobPackList_reducer.jobPacks;
};
export const selectFilteredList = createSelector(
    [
        selectJobPacks,
        selectSearchValue,
        selectDateFrom,
        selectDateTo,
        selectOrderByValue,
        selectOrderKeyValue
    ],
    (jobs, searchVal, dateFrom, dateTo, order, key) => {
        let list = null;
        if (order === "reverse") list = _.sortBy(jobs, [key]).reverse();
        else list = _.sortBy(jobs, [key]);
        let object = [];
        Object.keys(list).map((e, i) => {
            if (list[e].profile === undefined) {
                if (list[e].deleted === false) object.push(list[e]);
            } else {
                if (list[e].profile.deleted === false) object.push(list[e].profile);
            }
            return e;
        });
        if (dateTo !== false && dateFrom !== false) {
            dateFrom = new Date(dateFrom.setHours(0));
            object = filterByDate(object, dateFrom, dateTo);
        }
        if (searchVal === "") return object;
        let newList = [];
        object.map(e => {
            if (e.job_name.includes(searchVal) || e.job_id.includes(searchVal)) newList.push(e);
            return e;
        });

        return newList;
    }
);
function filterByDate(orderedDailyReports, dateFrom, dateTo) {
    return _.filter(orderedDailyReports, e => {
        let dateParts = e.timestamp.split("-");
        let current = new Date(dateParts[2].split(" ", 1), dateParts[1] - 1, dateParts[0]);

        return current >= dateFrom && current <= dateTo;
    });
}
